
import {Component, Vue} from 'vue-property-decorator';
import {readAdminSearchEngines} from '@/store/admin/getters';
import {dispatchDeleteSearchEngine, dispatchGetSearchEnginesAdmin} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import {dispatchGetForms} from '@/store/main/actions';

@Component({
  components: {DynamicTable},
})
export default class SearchEngineList extends Vue {

  public headers = [
    // router_name: 'main-admin-forms_search_engines-edit'
    {
      text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-search-engine-edit', width: '100px', delete_function: this.deleteFunction,
    },
    {text: this.$t('name'), value: 'name', sortable: true, align: 'left'},
    {text: this.$t('description'), value: 'description', sortable: true, align: 'left'},
    {text: this.$t('reference_type'), value: 'reference_type', sortable: true, align: 'left'},
    {text: this.$t('reference_key'), value: 'reference_key', sortable: true, align: 'left'},
    {text: this.$t('formID'), value: 'form_id', sortable: true, align: 'left'},
    {text: this.$t('created_by_user'), sortable: false, value: 'created_by_user', align: 'left', type: 'user_object'},
    {text: this.$t('updated_by_user'), sortable: false, value: 'updated_by_user', align: 'left', type: 'user_object'},
    // {text: this.$t('fieldSearch'), value: 'field_search', sortable: true, align: 'left'},
  ];

  public async mounted() {
    await dispatchGetSearchEnginesAdmin(this.$store);
  }

  private async deleteFunction(id) {
    await dispatchDeleteSearchEngine(this.$store, id);
    await dispatchGetSearchEnginesAdmin(this.$store);
    await dispatchGetForms(this.$store);
  }


  private get searchEngines() {
    return readAdminSearchEngines(this.$store);
  }
}
